/* Film rail
   The rail: native horizontal scrolling dressed with arrows, a progress line,
   a counter, drag-to-scroll and a "Play" cursor on pointer devices. Posters
   only; a silent preview is fetched when a card is hovered (desktop) or
   centred (touch, where the browser can stream HLS on its own).
   The theatre: one native <dialog> per section, one <video>, a panel per
   film. Products with a moment light up as they come into shot and can pull
   the film to their second. Back button and Escape both close it. */
(function () {
  'use strict';
  if (window.FilmRailInit) return;

  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SAVE_DATA = !!(navigator.connection && navigator.connection.saveData);
  var HLS_NATIVE = (function () {
    var v = document.createElement('video');
    return !!(v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl'));
  })();
  var SOUND_KEY = 'filmrail.sound';

  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function q(root, sel) { return root.querySelector(sel); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function noop() {}
  function swallow(p) { if (p && typeof p.catch === 'function') p.catch(noop); }

  function init(root) {
    if (!root || root.__filmRail) return;
    root.__filmRail = true;
    root.classList.add('is-js');

    var sid = root.getAttribute('data-section-id') || '';
    var films;
    try { films = JSON.parse(q(root, '[data-film-manifest]').textContent); } catch (e) { films = []; }
    if (!films.length) return;

    var previewsOn = root.getAttribute('data-hover-preview') !== 'false';
    var autoAdvance = root.getAttribute('data-auto-advance') !== 'false';

    /* ---------- Rail ---------- */
    var viewport = q(root, '[data-film-viewport]');
    var trackEl = q(root, '[data-film-track]');
    var items = qa(root, '[data-film-item]');
    var cards = qa(root, '[data-film-card]');
    var prevBtn = q(root, '[data-film-prev]');
    var nextBtn = q(root, '[data-film-next]');
    var currentEl = q(root, '[data-film-current]');
    var progressTrack = q(root, '[data-film-progress-track]');
    var progress = q(root, '[data-film-progress]');
    var cursor = q(root, '[data-film-cursor]');

    function edgePx() { return parseFloat(getComputedStyle(trackEl).paddingLeft) || 0; }
    function cardStep() {
      var a = items[0], b = items[1];
      if (!a) return 0;
      return b ? b.getBoundingClientRect().left - a.getBoundingClientRect().left : a.offsetWidth;
    }
    function itemOffset(item) {
      return item.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft - edgePx();
    }

    var scrollTick = false;
    function onScroll() {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(function () {
        scrollTick = false;
        var max = viewport.scrollWidth - viewport.clientWidth;
        var x = viewport.scrollLeft;
        var frac = max > 0 ? Math.min(1, Math.max(0, x / max)) : 0;
        if (progress && progressTrack) {
          var w = Math.max(8, viewport.clientWidth / Math.max(1, viewport.scrollWidth) * 100);
          progress.style.width = w + '%';
          progress.style.transform = 'translateX(' + (frac * (progressTrack.clientWidth - progress.offsetWidth)) + 'px)';
          progressTrack.setAttribute('aria-valuenow', Math.round(frac * 100));
        }
        var step = cardStep();
        var i = step ? Math.round(x / step) : 0;
        if (currentEl) currentEl.textContent = pad(Math.min(items.length, Math.max(1, i + 1)));
        if (prevBtn) prevBtn.disabled = x <= 2;
        if (nextBtn) nextBtn.disabled = max <= 2 || x >= max - 2;
      });
    }
    viewport.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    function scrollCards(dir) {
      var step = cardStep() || viewport.clientWidth;
      var perPage = Math.max(1, Math.floor(viewport.clientWidth / step) - 1);
      viewport.scrollBy({ left: dir * step * perPage, behavior: REDUCED.matches ? 'auto' : 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollCards(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollCards(1); });

    /* The progress thumb is also a direct scrollbar for the rail. */
    var progressDrag = null;
    function scrollToProgress(clientX, offset, behavior) {
      var max = viewport.scrollWidth - viewport.clientWidth;
      var trackRect = progressTrack.getBoundingClientRect();
      var thumbWidth = progress.offsetWidth;
      var travel = Math.max(0, trackRect.width - thumbWidth);
      var position = Math.min(travel, Math.max(0, clientX - trackRect.left - offset));
      viewport.scrollTo({
        left: travel ? position / travel * max : 0,
        behavior: behavior || (REDUCED.matches ? 'auto' : 'smooth')
      });
    }
    if (progressTrack && progress) {
      progressTrack.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        var thumbRect = progress.getBoundingClientRect();
        progressDrag = { id: e.pointerId, offset: e.clientX - thumbRect.left };
        progressTrack.classList.add('is-dragging');
        viewport.classList.add('is-progress-dragging');
        try { progressTrack.setPointerCapture(e.pointerId); } catch (err) {}
        scrollToProgress(e.clientX, progressDrag.offset, 'auto');
        e.preventDefault();
      });
      progressTrack.addEventListener('pointermove', function (e) {
        if (!progressDrag || e.pointerId !== progressDrag.id) return;
        scrollToProgress(e.clientX, progressDrag.offset, 'auto');
        e.preventDefault();
      });
      function endProgressDrag() {
        if (!progressDrag) return;
        progressDrag = null;
        progressTrack.classList.remove('is-dragging');
        viewport.classList.remove('is-progress-dragging');
      }
      progressTrack.addEventListener('pointerup', endProgressDrag);
      progressTrack.addEventListener('pointercancel', endProgressDrag);
      progressTrack.addEventListener('keydown', function (e) {
        var max = viewport.scrollWidth - viewport.clientWidth;
        var step = cardStep() || viewport.clientWidth;
        var left = viewport.scrollLeft;
        if (e.key === 'ArrowLeft') left = Math.max(0, left - step);
        else if (e.key === 'ArrowRight') left = Math.min(max, left + step);
        else if (e.key === 'Home') left = 0;
        else if (e.key === 'End') left = max;
        else return;
        viewport.scrollTo({ left: left, behavior: REDUCED.matches ? 'auto' : 'smooth' });
        e.preventDefault();
      });
    }

    /* Drag to scroll with a mouse. Touch keeps the browser's own momentum. */
    var drag = null, suppressClick = false;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: viewport.scrollLeft, moved: false, id: e.pointerId };
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 6) {
        drag.moved = true;
        viewport.classList.add('is-grabbing', 'is-dragging');
        if (cursor) cursor.classList.add('is-drag');
        try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (drag.moved) { viewport.scrollLeft = drag.left - dx; e.preventDefault(); }
    });
    function endDrag() {
      if (!drag) return;
      var moved = drag.moved;
      drag = null;
      viewport.classList.remove('is-grabbing');
      if (cursor) cursor.classList.remove('is-drag');
      if (moved) {
        suppressClick = true;
        setTimeout(function () { suppressClick = false; viewport.classList.remove('is-dragging'); }, 0);
      }
    }
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('click', function (e) { if (suppressClick) { e.preventDefault(); e.stopPropagation(); } }, true);

    /* The "Play" cursor */
    if (cursor && FINE.matches) {
      root.classList.add('is-cursor');
      viewport.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        cursor.style.setProperty('--x', e.clientX + 'px');
        cursor.style.setProperty('--y', e.clientY + 'px');
        var over = !!(e.target.closest && e.target.closest('.FilmCard__Open'));
        cursor.classList.toggle('is-on', over || !!(drag && drag.moved));
      });
      viewport.addEventListener('pointerleave', function () { cursor.classList.remove('is-on'); });
      viewport.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') cursor.classList.add('is-on'); });
    }

    /* Previews */
    var liveCard = null, previewTimer = null;
    function previewSrc(card) {
      var mp4 = card.getAttribute('data-preview-mp4') || '';
      var hls = card.getAttribute('data-preview-hls') || '';
      if (FINE.matches) return mp4 || (HLS_NATIVE ? hls : '');
      return HLS_NATIVE ? hls : '';
    }
    function stopPreviews() {
      clearTimeout(previewTimer);
      if (!liveCard) return;
      var v = q(liveCard, 'video');
      if (v) { v.pause(); try { v.currentTime = 0; } catch (e) {} }
      liveCard.classList.remove('is-live');
      liveCard = null;
    }
    function startPreview(card) {
      if (!previewsOn || SAVE_DATA || REDUCED.matches || document.hidden) return;
      if (liveCard === card) return;
      stopPreviews();
      var v = q(card, 'video');
      var src = previewSrc(card);
      if (!v || !src) return;
      if (!v.getAttribute('src')) v.setAttribute('src', src);
      liveCard = card;
      v.onplaying = function () { if (liveCard === card) card.classList.add('is-live'); };
      swallow(v.play());
    }
    cards.forEach(function (card) {
      card.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(previewTimer);
        previewTimer = setTimeout(function () { startPreview(card); }, 140);
      });
      card.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(previewTimer);
        if (liveCard === card) stopPreviews();
      });
    });
    if (!FINE.matches && 'IntersectionObserver' in window) {
      var centred = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var card = q(en.target, '[data-film-card]');
          if (!card) return;
          if (en.isIntersecting && en.intersectionRatio >= 0.85) startPreview(card);
          else if (liveCard === card) stopPreviews();
        });
      }, { root: viewport, threshold: [0.85] });
      items.forEach(function (it) { centred.observe(it); });
    }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stopPreviews(); });

    /* Reveal */
    if ('IntersectionObserver' in window) {
      var reveal = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { root.classList.add('is-inview'); reveal.disconnect(); } });
      }, { threshold: 0.12 });
      reveal.observe(root);
    } else {
      root.classList.add('is-inview');
    }

    /* ---------- Theatre ---------- */
    var dialog = q(root, '[data-film-theatre]');
    var stage = q(root, '[data-film-stage]');
    var video = q(root, '[data-film-video]');
    var ambient = q(root, '[data-film-ambient]');
    var panelEl = q(root, '[data-film-panel]');
    var panelItems = qa(root, '[data-film-panel-item]');
    var panelCurrent = q(root, '[data-film-panel-current]');
    var closeBtn = q(root, '[data-film-close]');
    var toggleBtn = q(root, '[data-film-toggle-btn]');
    var soundBtn = q(root, '[data-film-sound]');
    var fullBtn = q(root, '[data-film-full]');
    var seek = q(root, '[data-film-seek]');
    var curEl = q(root, '[data-film-cur]');
    var durEl = q(root, '[data-film-dur]');
    var hint = q(root, '[data-film-hint]');
    var endedEl = q(root, '[data-film-ended]');
    var nextTitle = q(root, '[data-film-next-title]');
    var nextBtnEnded = q(root, '[data-film-next-btn]');
    var nowChip = q(root, '[data-film-now]');
    var nowImg = q(root, '[data-film-now-img]');
    var nowTitle = q(root, '[data-film-now-title]');
    var nowPrice = q(root, '[data-film-now-price]');
    var toast = q(root, '[data-film-toast]');
    var steps = qa(root, '[data-film-step]');

    if (!dialog || !video || typeof dialog.showModal !== 'function') return;

    var current = -1, openerEl = null, products = [], nowIndex = -1, scrubbing = false, idleTimer = null, closing = false;

    function track(action, film, extra) {
      var d = { action: action, film: film ? film.title : '', slug: film ? film.slug : '' };
      if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) d[k] = extra[k];
      try { root.dispatchEvent(new CustomEvent('film-rail:' + action, { bubbles: true, detail: d })); } catch (e) {}
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'film_rail', film_action: action, film_title: d.film, film_slug: d.slug, film_url: d.url, film_variant: d.variant });
      }
    }

    function soundOn() { try { return sessionStorage.getItem(SOUND_KEY) !== 'off'; } catch (e) { return true; } }
    function setSound(on) {
      try { sessionStorage.setItem(SOUND_KEY, on ? 'on' : 'off'); } catch (e) {}
      video.muted = !on;
      dialog.classList.toggle('is-muted', !on);
      if (soundBtn) soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on && hint) hint.hidden = true;
    }

    function lock(on) { document.documentElement.classList.toggle('FilmTheatre--lock', on); }
    function hashFor(i) { return 'film-' + films[i].slug; }
    function indexForHash(h) {
      if (!h || h.indexOf('#film-') !== 0) return -1;
      var slug = h.slice(6);
      for (var i = 0; i < films.length; i++) if (films[i].slug === slug) return i;
      return -1;
    }

    function play() {
      video.muted = !soundOn();
      dialog.classList.toggle('is-muted', video.muted);
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.catch(function () {
          if (!video.muted) {
            video.muted = true;
            dialog.classList.add('is-muted');
            if (soundBtn) soundBtn.setAttribute('aria-pressed', 'false');
            if (hint) hint.hidden = false;
            swallow(video.play());
          }
        });
      }
    }

    function clearSources() {
      video.pause();
      video.removeAttribute('src');
      while (video.firstChild) video.removeChild(video.firstChild);
    }
    function addSource(url, type) {
      var s = document.createElement('source');
      s.src = url; s.type = type;
      video.appendChild(s);
    }

    function flip(from, f) {
      if (REDUCED.matches || !from || !f.poster || typeof Element.prototype.animate !== 'function') return;
      var s = stage.getBoundingClientRect();
      if (!s.width || !s.height) return;
      var r = f.ratio || 1.7778;
      var to;
      if (getComputedStyle(video).objectFit === 'cover') {
        to = { left: s.left, top: s.top, width: s.width, height: s.height };
      } else {
        var w = Math.min(s.width, s.height * r), h = w / r;
        to = { left: s.left + (s.width - w) / 2, top: s.top + (s.height - h) / 2, width: w, height: h };
      }
      var g = document.createElement('img');
      g.className = 'FilmTheatre__Ghost';
      g.alt = '';
      g.src = f.poster;
      g.style.left = from.left + 'px'; g.style.top = from.top + 'px';
      g.style.width = from.width + 'px'; g.style.height = from.height + 'px';
      dialog.appendChild(g);
      var a = g.animate([
        { left: from.left + 'px', top: from.top + 'px', width: from.width + 'px', height: from.height + 'px', borderRadius: '4px' },
        { left: to.left + 'px', top: to.top + 'px', width: to.width + 'px', height: to.height + 'px', borderRadius: '0px' }
      ], { duration: 640, easing: 'cubic-bezier(0.2, 0.75, 0.2, 1)', fill: 'forwards' });
      a.onfinish = function () {
        var b = g.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 260, fill: 'forwards' });
        b.onfinish = function () { if (g.parentNode) g.parentNode.removeChild(g); };
      };
    }

    function clearNow() {
      nowIndex = -1;
      products.forEach(function (p) { p.classList.remove('is-now'); });
      if (nowChip) { nowChip.classList.remove('is-on'); nowChip.hidden = true; }
    }
    function updateNow(t) {
      var active = -1;
      for (var i = 0; i < products.length; i++) {
        var pt = parseFloat(products[i].getAttribute('data-time'));
        if (!isNaN(pt) && pt >= 0 && t + 0.05 >= pt) active = i;
      }
      if (active === nowIndex) return;
      nowIndex = active;
      products.forEach(function (p, i) { p.classList.toggle('is-now', i === active); });
      if (!nowChip) return;
      if (active < 0) { nowChip.classList.remove('is-on'); return; }
      var p = products[active];
      nowChip.href = p.getAttribute('data-url') || '#';
      if (nowTitle) nowTitle.textContent = p.getAttribute('data-title') || '';
      if (nowPrice) nowPrice.textContent = p.getAttribute('data-price') || '';
      if (nowImg) { var th = p.getAttribute('data-thumb') || ''; nowImg.src = th; nowImg.hidden = !th; }
      nowChip.hidden = false;
      nowChip.classList.remove('is-on');
      void nowChip.offsetWidth;
      nowChip.classList.add('is-on');
    }

    function show(index, fromRect) {
      var f = films[index];
      if (!f) return;
      current = index;
      panelItems.forEach(function (el, i) { el.hidden = i !== index; });
      var h3 = panelItems[index] && panelItems[index].querySelector('h3');
      if (h3) dialog.setAttribute('aria-labelledby', h3.id);
      if (panelCurrent) panelCurrent.textContent = pad(index + 1);
      steps.forEach(function (b) {
        var dir = parseInt(b.getAttribute('data-film-step'), 10);
        b.disabled = dir < 0 ? index === 0 : index >= films.length - 1;
      });
      var nf = films[index + 1];
      if (nextTitle) nextTitle.textContent = nf ? nf.title : '';
      if (nextBtnEnded) nextBtnEnded.hidden = !nf;
      stage.style.setProperty('--stage-ratio', String(f.ratio || 1.7778));
      if (ambient) { if (f.poster) { ambient.src = f.poster; ambient.hidden = false; } else { ambient.hidden = true; } }

      clearSources();
      if (f.poster) video.setAttribute('poster', f.poster); else video.removeAttribute('poster');
      if (HLS_NATIVE && f.hls) addSource(f.hls, 'application/vnd.apple.mpegurl');
      if (f.mp4) addSource(f.mp4, 'video/mp4');
      video.load();

      products = qa(panelItems[index] || root, '[data-film-product]');
      clearNow();
      if (durEl) durEl.textContent = fmt(f.duration);
      if (curEl) curEl.textContent = '0:00';
      if (seek) seek.value = 0;
      if (endedEl) endedEl.hidden = true;
      dialog.classList.remove('is-ended', 'is-idle');
      if (toast) { toast.classList.remove('is-on'); toast.hidden = true; }
      if (panelEl) panelEl.scrollTop = 0;

      if (fromRect) flip(fromRect, f);
      play();
    }

    function open(index, opener, viaHistory) {
      if (!films[index] || closing) return;
      openerEl = opener || null;
      var media = opener && opener.querySelector ? opener.querySelector('.FilmCard__Media') : null;
      var fromRect = media ? media.getBoundingClientRect() : null;
      stopPreviews();
      var wasOpen = dialog.open;
      if (!wasOpen) {
        lock(true);
        try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
        requestAnimationFrame(function () { requestAnimationFrame(function () { dialog.classList.add('is-open'); }); });
        if (!viaHistory) {
          try { history.pushState({ filmRail: sid, film: index }, '', '#' + hashFor(index)); } catch (e) {}
        }
      }
      show(index, wasOpen ? null : fromRect);
      if (closeBtn) closeBtn.focus({ preventScroll: true });
      track('open', films[index]);
    }

    function go(index) {
      if (!films[index] || index === current) return;
      show(index, null);
      try { history.replaceState({ filmRail: sid, film: index, deep: history.state && history.state.deep }, '', '#' + hashFor(index)); } catch (e) {}
      track('open', films[index]);
    }

    function teardown() {
      clearSources();
      video.load();
      clearNow();
      lock(false);
      dialog.classList.remove('is-open', 'is-closing', 'is-ended', 'is-idle', 'is-paused');
      closing = false;
      if (openerEl && openerEl.focus) { try { openerEl.focus({ preventScroll: true }); } catch (e) {} }
      track('close', films[current]);
    }

    function close(viaHistory) {
      if (!dialog.open || closing) return;
      var st = null;
      try { st = history.state; } catch (e) {}
      if (!viaHistory && st && st.filmRail === sid && !st.deep) { history.back(); return; }
      if (!viaHistory && location.hash.indexOf('#film-') === 0) {
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      }
      closing = true;
      dialog.classList.add('is-closing');
      dialog.classList.remove('is-open');
      var done = function () {
        try { dialog.close(); } catch (e) { dialog.removeAttribute('open'); }
        teardown();
      };
      if (REDUCED.matches) done(); else setTimeout(done, 220);
    }

    /* Escape: run our own close so the exit is animated and history stays tidy */
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    /* If the browser closes it anyway (it may, on repeated Escape), tidy up */
    dialog.addEventListener('close', function () {
      if (closing) return;
      if (location.hash.indexOf('#film-') === 0) { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} }
      teardown();
    });
    window.addEventListener('popstate', function () { if (dialog.open) close(true); });

    if (closeBtn) closeBtn.addEventListener('click', function () { close(); });
    dialog.addEventListener('click', function (e) {
      /* A click on the dialog element itself is a click on the backdrop */
      if (e.target === dialog) close();
    });

    /* Playback controls */
    function togglePlay() { if (video.paused) { play(); } else { video.pause(); } }
    qa(root, '[data-film-toggle], [data-film-toggle-btn]').forEach(function (b) { b.addEventListener('click', togglePlay); });
    video.addEventListener('play', function () { dialog.classList.remove('is-paused'); if (toggleBtn) toggleBtn.setAttribute('aria-label', 'Pause'); armIdle(); });
    video.addEventListener('pause', function () { dialog.classList.add('is-paused'); dialog.classList.remove('is-idle'); if (toggleBtn) toggleBtn.setAttribute('aria-label', 'Play'); });
    video.addEventListener('loadedmetadata', function () { if (durEl && isFinite(video.duration)) durEl.textContent = fmt(Math.round(video.duration)); });
    video.addEventListener('timeupdate', function () {
      if (seek && !scrubbing && isFinite(video.duration) && video.duration > 0) seek.value = Math.round(video.currentTime / video.duration * 1000);
      if (curEl) curEl.textContent = fmt(video.currentTime);
      updateNow(video.currentTime);
    });
    video.addEventListener('ended', function () {
      if (autoAdvance && films[current + 1]) {
        setTimeout(function () { if (dialog.open && current + 1 < films.length) go(current + 1); }, 450);
        return;
      }
      dialog.classList.add('is-ended');
      dialog.classList.remove('is-idle');
      if (endedEl) endedEl.hidden = false;
    });
    if (seek) {
      seek.addEventListener('pointerdown', function () { scrubbing = true; });
      seek.addEventListener('input', function () { if (isFinite(video.duration)) video.currentTime = seek.value / 1000 * video.duration; });
      var endScrub = function () { scrubbing = false; };
      seek.addEventListener('pointerup', endScrub);
      seek.addEventListener('pointercancel', endScrub);
      seek.addEventListener('change', endScrub);
    }
    if (soundBtn) soundBtn.addEventListener('click', function () { setSound(!soundOn()); });
    if (fullBtn) fullBtn.addEventListener('click', function () {
      if (document.fullscreenElement) { document.exitFullscreen(); return; }
      if (stage.requestFullscreen) { swallow(stage.requestFullscreen()); }
      else if (video.webkitEnterFullscreen) { video.webkitEnterFullscreen(); }
    });
    var replay = q(root, '[data-film-replay]');
    if (replay) replay.addEventListener('click', function () {
      if (endedEl) endedEl.hidden = true;
      dialog.classList.remove('is-ended');
      video.currentTime = 0;
      play();
    });
    steps.forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = parseInt(b.getAttribute('data-film-step'), 10);
        if (endedEl) endedEl.hidden = true;
        go(current + dir);
      });
    });

    /* Hide the controls while a film plays untouched */
    function armIdle() {
      clearTimeout(idleTimer);
      dialog.classList.remove('is-idle');
      if (!FINE.matches) return;
      idleTimer = setTimeout(function () { if (!video.paused && !video.ended) dialog.classList.add('is-idle'); }, 2600);
    }
    stage.addEventListener('pointermove', armIdle);
    stage.addEventListener('pointerdown', armIdle);
    dialog.addEventListener('focusin', armIdle);

    /* Swipe between films on touch */
    var swipe = null;
    stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') swipe = { x: e.clientX, y: e.clientY }; });
    stage.addEventListener('pointerup', function (e) {
      if (!swipe || e.pointerType !== 'touch') return;
      var dx = e.clientX - swipe.x, dy = e.clientY - swipe.y;
      swipe = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) go(current + (dx < 0 ? 1 : -1));
    });

    /* Keyboard inside the theatre */
    dialog.addEventListener('keydown', function (e) {
      var t = e.target;
      var typing = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA');
      if (e.key === 'ArrowRight' && !typing) { e.preventDefault(); go(current + 1); }
      else if (e.key === 'ArrowLeft' && !typing) { e.preventDefault(); go(current - 1); }
      else if ((e.key === ' ' || e.key === 'k') && !(t && (t.tagName === 'BUTTON' || t.tagName === 'A' || typing))) { e.preventDefault(); togglePlay(); }
      else if (e.key === 'm' && !typing) { setSound(!soundOn()); }
      else if (e.key === 'f' && !typing && fullBtn) { fullBtn.click(); }
    });

    /* Panel: moments, quick add, share, product clicks */
    if (panelEl) panelEl.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      var seekBtn = t.closest('[data-film-seek-to]');
      if (seekBtn) {
        var secs = parseFloat(seekBtn.getAttribute('data-film-seek-to')) || 0;
        if (endedEl) endedEl.hidden = true;
        dialog.classList.remove('is-ended');
        try { video.currentTime = secs; } catch (err) {}
        play();
        updateNow(secs);
        track('moment', films[current], { seconds: secs });
        return;
      }
      var add = t.closest('[data-film-add]');
      if (add) { addToCart(add); return; }
      var share = t.closest('[data-film-share]');
      if (share) { shareFilm(share); return; }
      var link = t.closest('a[href]');
      if (link) track('product', films[current], { url: link.getAttribute('href') });
    });
    if (nowChip) nowChip.addEventListener('click', function () { track('product', films[current], { url: nowChip.getAttribute('href'), from: 'chip' }); });

    function addToCart(btn) {
      var id = parseInt(btn.getAttribute('data-film-add'), 10);
      if (!id || btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding';
      var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';
      fetch(cartUrl + '/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        if (toast) { toast.hidden = false; void toast.offsetWidth; toast.classList.add('is-on'); }
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
        track('add_to_cart', films[current], { variant: id });
        setTimeout(function () { btn.disabled = false; btn.textContent = label; btn.classList.remove('is-added'); }, 2600);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; }, 2000);
      });
    }

    function shareFilm(btn) {
      var url = location.origin + location.pathname + location.search + '#' + hashFor(current);
      var done = function () { var t = btn.textContent; btn.textContent = 'Link copied'; setTimeout(function () { btn.textContent = t; }, 2000); };
      if (navigator.share && !FINE.matches) {
        navigator.share({ title: films[current].title, url: url }).then(function () { track('share', films[current]); }).catch(noop);
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(noop);
      } else {
        try { window.prompt('Copy this link', url); } catch (e) {}
      }
      track('share', films[current]);
    }

    /* Cards open the theatre */
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-film-open]');
      if (!b || suppressClick) return;
      e.preventDefault();
      open(parseInt(b.getAttribute('data-film-open'), 10), b);
    });

    /* Deep links: /#film-<slug> opens straight into the film */
    var deep = indexForHash(location.hash);
    if (deep >= 0) {
      try { history.replaceState({ filmRail: sid, film: deep, deep: true }, '', location.href); } catch (e) {}
      var openerCard = q(root, '[data-film-open="' + deep + '"]');
      setTimeout(function () { open(deep, openerCard, true); }, 60);
    }

    /* Theme editor: keep the selected card in view */
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target)) return;
      var item = e.target.closest ? e.target.closest('[data-film-item]') : null;
      if (item) viewport.scrollTo({ left: itemOffset(item), behavior: 'smooth' });
    });

    setSound(soundOn());
    onScroll();
  }

  function boot() { qa(document, '[data-film-rail]').forEach(init); }
  window.FilmRailInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { qa(e.target, '[data-film-rail]').forEach(init); });
})();
